<style lang="scss" scoped>
.articleLib {
  /deep/ {
    .el-dialog__body {
      padding: 10px 0 30px 0;
    }
  }
}
.form {
  width: 700px;
  margin: 40px auto 100px;
}
</style>

<template>
  <div>
    <div class="lib" @click="show">
      <slot></slot>
    </div>
    <el-dialog
      title="新建视频"
      :visible.sync="dialog"
      width="1000px"
      top="10vh"
      class="articleLib"
      :append-to-body="true"
    >
      <el-form ref="form" :model="form" label-width="100px" class="form" label-position="left">
        <el-form-item label="标题">
          <el-input type="text" v-model="form.title" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <el-input type="text" v-model="form.digest" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="视频内容">
          <div style="color:#9B9B9B">请上传时长小于30分钟的视频，支持主流的 视频格式 ，超出限制的视频请到腾讯视频上传</div>
          <el-upload
            :show-file-list="false"
            style="display:inline-block"
            action
            :before-upload="beforeFn"
            :http-request="uploadVideo"
            accept="mp4"
          >
            <el-button type="info">上传文件</el-button>
          </el-upload>
          <ul class="el-upload-list el-upload-list--text" v-if="Object.keys(file).length">
            <li tabindex="0" class="el-upload-list__item is-success">
              <a class="el-upload-list__item-name">
                <i class="el-icon-document"></i>
                {{file.name}}
              </a>
              <label class="el-upload-list__item-status-label">
                <i class="el-icon-upload-success el-icon-circle-check"></i>
              </label>
              <i class="el-icon-close" @click="del"></i>
            </li>
          </ul>
        </el-form-item>
      </el-form>
      <div class="alignc">
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils.js';
export default {
  components: {},
  computed: {},
  props: ['id'],
  data() {
    return {
      form: {
        title: '',
        digest: '',
        videourl: '',
      },
      file: {},
      radio: '',
      dialog: false,
    };
  },
  watch: {
    'form.title': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        if (iLen > 50) {
          this.form.title = oldval;
        }
      },
    },
    'form.digest': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        if (iLen > 200) {
          this.form.digest = oldval;
        }
      },
    },
  },
  methods: {
    show() {
      this.dialog = true;
      this.form = {
        title: '',
        digest: '',
        videourl: '',
      };
    },
    async save() {
      if (this.form.title && this.form.digest && this.form.videourl) {
        let res = await this.$http.post(
          `/api/${this.id}/material/video`,
          this.form,
        );
        let data = Object.assign({}, res);
        this.$emit('confirm', data);
        this.dialog = false;
      } else {
        this.$message.error(`请完善信息`);
      }
    },
    err(err) {
      console.log(err);
    },
    async uploadVideo(file) {
      let fd = new FormData();
      fd.append('File', file.file);
      fd.append('Type', '5');
      let res = await this.$http.post(
        `/api/${this.id}/material/file/upload`,
        fd,
      );
      console.log(res);
      this.file = res;
      this.form.videourl = res.url;
      return;
    },
    del() {
      this.file = {};
      this.form.videourl = '';
    },
    beforeFn(file) {
      if (file.size > 10240 * 1024) {
        this.$message.error(`视频大小不能超过10mb`);
        return false;
      }
      return true;
    },
  },
  mounted() {},
};
</script>
